import { Underline } from '.';
import { markInputRule, markPasteRule } from '@tiptap/core';

// Match text with two plus signs on either side
// Example: ++underline++
const inputRegex = /(?:^|\s)(\+{2}([^+]+)\+{2})$/;
const pasteRegex = /(?:^|\s)(\+{2}([^+]+)\+{2})/g;

export const CustomUnderline = Underline.extend({
   addInputRules() {
      return [
         markInputRule({
            find: inputRegex,
            type: this.type,
         }),
      ];
   },

   addPasteRules() {
      return [
         markPasteRule({
            find: pasteRegex,
            type: this.type,
         }),
      ];
   },
});
